import { Component, OnDestroy, OnInit } from "@angular/core";
import { typeMessage } from "@app/components/modals/modal-payment-claims/modal-payment-claims.component";
import { AffiliatesListModel, AffiliatesResponse } from "@app/models/SearchAffiliate.model";
import { SearchAffiliateModel } from "@app/models/SearchAffiliateModel";
import { AffiliateDataModel, BackingsToProcessRequestModel } from "@app/models/backingsToProcessRequest.model";
import {
  BackingsToProcessDataModel,
  BackingsToProcessResponseModel,
} from "@app/models/backingsToProcessResponse.model";
import { PaymentProcessBackingRequest } from "@app/models/paymentProcessBacking.model";
import { ClaimsUploadFile } from "@app/models/util/checkstatus-upload.model";
import { AssignationFileData, FileData, ImagesFiles } from "@app/models/util/claims";
import { BackupsService } from "@app/services/backups.service";
import { HelperService } from "@app/services/helper.service";
import { ModalService } from "@app/services/modal.service";
import { SubjectService } from "@app/services/subject.service";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import Swal from "sweetalert2";



@Component({
  selector: "app-check-status",
  templateUrl: "./check-status.component.html",
  styleUrls: ["./check-status.component.scss"],
})
export class CheckStatusComponent implements OnInit , OnDestroy{
  public dataStatusBacking: BackingsToProcessDataModel[] = [];
  public dataUserLoged: any;
  public tableHeaders: any;
  public totalPages: number = 1;
  public affiliateData: AffiliateDataModel = new AffiliateDataModel()
  public showLoader: boolean = true;
  public modalMessage: typeMessage;
  public messageText: string;

  public files: File[] = [];
  public showModalUploadFiles: number = null;
  public selectedAssignationFileData: AssignationFileData;
  public dataSelectedToUploadFiles: BackingsToProcessDataModel;
  public assignationFileDataList: ClaimsUploadFile[] = [];
  
  public navItemTabsInfo = [
    {
      href: '#uploadFiles',
      description: 'Cargue Documentos',
      icon: 'icon-tab-individual.svg'
    },
    {
      href: '#payment',
      description: 'Abono',
      icon: 'icon-tab-massive.svg'
    },
  ];

  public currentTab: string = "#uploadFiles";
  public paymentClaim: number | null = 0;

  protected dataResponseSearchFilter:AffiliatesListModel;
  
  private subscription: Subscription;

  constructor(
    protected backupServices: BackupsService, 
    public subject: SubjectService,
    public modalService: ModalService,
    protected toast: ToastrService,
    public helper: HelperService ) {
    this.dataUserLoged = JSON.parse(sessionStorage.getItem('user')).userInfo;
  }
  
  ngOnInit() {
    this.subject.headerCollapse(true);
    this.getSearchFilter();
    this.tableHeaders = {
      headersFile: [
        { name: "Cargar Documentos" },
        { name: "Estado radicación" },
        { name: "Producto" },
        { name: "Fecha radicación" },
        { name: "Numero radicación" },
        { name: "Título valor" },
        { name: "Valor reclamado" },
        { name: "Documento comprador" },
        { name: "Nombre comprador" },
        { name: "Fecha vencimiento" },
      ],
    };
  }
  
  ngOnDestroy(): void {
   if( this.subscription )  this.subscription.unsubscribe();
   this.subject.headerCollapse(false);
  }

  get statusClaims() : boolean {
    const typeStatus: string[] = ['ACTIVO','REVISADO','AUTORIZADO DE PAGO'];

    if (!this.dataSelectedToUploadFiles.filingStatus) return false;
    if (typeStatus.includes(this.dataSelectedToUploadFiles.filingStatus)) return true;
    return false;
  }

  getStatusHomologate(status:string) {
    const homolagateData = {
      'ACTIVO':'En Revisión',
      'AUTORIZADO DE PAGO':'En programación para pago',
      'DEVUELTO':'Devuelto',
      'REVISADO':'Revisado',
      'SUBSANABLE':'Subsanable',
      'CONDONACION CAPITAL':'Pagado',
      'CON PAGO COBERTURA':'Pagado',
      'CON PAGO TOTAL':'Pagado',
      'DESBLOQUEO CERTIFICA':'Pagado',
      'DESBLOQUEO DENCIO':'Pagado',
      'DESBLOQUEO SENTENCIA':'Pagado',
    }
    return homolagateData[status] || '';
  }

  getSearchFilter() {
    this.showLoader = true;
    const dataRequest: SearchAffiliateModel = new SearchAffiliateModel();

    dataRequest.search = this.dataUserLoged.DOCUMENTO;
    dataRequest.filter = this.dataUserLoged.TIPO_DOCUMENTO === 'C'? 'Documento comprador' : 'Documento afiliado';

    this.subscription = this.backupServices
      .getAffiliate(dataRequest)
      .subscribe((responseSearchFilter: AffiliatesResponse) => {
        // if()
        this.showLoader = false;
        const index = this.indexForDataAvailable(responseSearchFilter.data);
        
        this.affiliateData.name = responseSearchFilter.data[index].socialReason;
        this.affiliateData.document = responseSearchFilter.data[index].affiliateDocument;
        this.affiliateData.documentType = responseSearchFilter.data[index].affiliateDocumentType;
        this.dataResponseSearchFilter = responseSearchFilter.data[index]
        this.processDataResponseSearchFilter();
      },
      error => {
        this.showLoader = false;
      });
  }

  processDataResponseSearchFilter(currentPage?: number) {

    const {
      affiliateDocumentType,
      affiliateDocument,
      contract,
      sinisterNumber,
      issuerDocument,
      issuerDocumentType,
    } = this.dataResponseSearchFilter;

    const dataBackingRequest: BackingsToProcessRequestModel =
      new BackingsToProcessRequestModel();
    
    dataBackingRequest.affiliateDocumentType = this.dataUserLoged.TIPO_DOCUMENTO === 'C' ? issuerDocumentType : affiliateDocumentType;
    dataBackingRequest.affiliateDocument = this.dataUserLoged.TIPO_DOCUMENTO === 'C' ? issuerDocument : String(affiliateDocument);
    dataBackingRequest.contract = contract;
    dataBackingRequest.sinisterNumber = sinisterNumber;
    dataBackingRequest.issuerDocument = "0";
    dataBackingRequest.issuerDocumentType = "0";
    dataBackingRequest.currentPage = currentPage ? currentPage : dataBackingRequest.currentPage;

    const date = new Date();
    const initialDateDate = new Date(date.setMonth(date.getMonth() - 12));
    dataBackingRequest.initialDate = this.formatDate(initialDateDate.toISOString(), 'initialHour');
    dataBackingRequest.finalDate = this.formatDate(new Date().toISOString(), 'finalHour');

    this.getBackingToProcess(dataBackingRequest);
  }

  getBackingToProcess(backingDataRequest: BackingsToProcessRequestModel) {
    this.subscription = this.backupServices
      .getBackingToProcces(backingDataRequest)
      .subscribe((responseBackingProcess: BackingsToProcessResponseModel) => {
        this.totalPages = responseBackingProcess.totalPages;
        this.dataStatusBacking = responseBackingProcess.data;
      },
      error => {
        this.showLoader = false;
      });
  }
  
  goToPage(event: any) {
    this.processDataResponseSearchFilter((event.currentPage));
  }

  indexForDataAvailable(data:AffiliatesListModel[]){
    let returnIndex: number = 0;
    data.forEach((affiliate,index) => {
      if(affiliate.affiliateDocument && affiliate.affiliateDocumentType && affiliate.affiliateDocument !== "0" && affiliate.affiliateDocumentType !== "0") {
        returnIndex = index
      }}
    )

    return returnIndex;
  }

  formatDate(dateToConvert: string, typeHour: 'initialHour'|'finalHour' ) {
    const date = new Date(dateToConvert);

    const año = date.getFullYear();
    const mes = String(this.validateMonth(date.getMonth(), date.getDate())).padStart(2, "0");
    const dia = String(this.validateDay(date.getMonth(), date.getDate())).padStart(2, "0");
    const hora = typeHour === 'initialHour' ? '00' : '23'
    const minutos = typeHour === 'initialHour' ? '00' : '59'
    const segundos = typeHour === 'initialHour' ? '00' : '59'

    return `${año}-${mes}-${dia} ${hora}:${minutos}:${segundos}`;
  }

  validateDay(month: number, day: number) {
    const currentMonth = new Date().getMonth();
    //function deleted
    return day;
  }
  
  validateMonth(month: number, day: number) {
    const currentMonth = new Date().getMonth();
    //function deleted
    return month+1;
  }

  checkedItemsSettlement(data: BackingsToProcessDataModel) {
    this.dataSelectedToUploadFiles = data;
    this.paymentClaim = null;
    const product = !this.dataSelectedToUploadFiles.subProduct ? this.dataSelectedToUploadFiles.sinisterProduct : this.dataSelectedToUploadFiles.subProduct;
    this.assignationFileDataList = this.listDocumentsUpload(product);
    if(this.statusClaims == false) this.currentTab = '#uploadFiles'
  }

  openModal(index: number) {
    this.showModalUploadFiles = index;
  }

  closeModal() {
    this.showModalUploadFiles = null;
  }

  saveDataFile(uploads: FileData[]) {
    const {filingNumber} = this.dataSelectedToUploadFiles;
    const {title} = this.assignationFileDataList[this.showModalUploadFiles];

    uploads.forEach((upload, index) => {
      const originalName = upload.fileName;
      upload.fileName = `cv${filingNumber}_${title}-${originalName}`;
    });

    this.assignationFileDataList[this.showModalUploadFiles].uploads = uploads;
    console.log(this.assignationFileDataList[this.showModalUploadFiles]);
  }

  goToPaymentClaim() {
    if(this.paymentClaim === this.dataSelectedToUploadFiles.claimedValue ) {
      this.modalMessage = 'giveUp';
      this.modalService.show('modalPaymentClaims');
    } else {
      this.handlePaymentClaim(true);
    }
  }

  handlePaymentClaim($event?: any) {
    if($event === false) return;
    if(this.modalMessage === 'error' || this.modalMessage === 'success') {
      this.modalMessage = null;
      return;
    }

    const dataSend = this.setData();
    
    this.backupServices.setPaymentProcessBacking(dataSend)
      .subscribe(
        response => {
          if(response.status == 200) {
            this.modalMessage = 'success';
            this.messageText = response.message;
            this.paymentClaim = null;
            this.dataSelectedToUploadFiles = null;
            this.getSearchFilter();
          }
          this.modalService.show('modalPaymentClaims');
        },
        error => {
          this.modalMessage = 'error';
          this.messageText = error.error.message || error.message;
          this.modalService.show('modalPaymentClaims');
        }
    );
  }

  postSaveFiles() {
    this.showLoader = true;
    const sendFilesMultiples: ImagesFiles = {
      images: [],
    };
    
    for (let element of this.assignationFileDataList) {
      for (let file of element.uploads) {
        sendFilesMultiples.images.push({
          document: this.dataSelectedToUploadFiles.issuerDocument,
          documentType: this.dataSelectedToUploadFiles.issuerDocumentType,
          userName: this.dataUserLoged.NOMBRE,
          fileName: file.fileName,
          fileExtension: file.fileExtension,
          category: "RECLAMACIONES",
          source: "PLATAFORMA COVIFACTURA",
          image: file.image,
        });
      }
    }

    this.backupServices.postSaveFiles(sendFilesMultiples).subscribe(
      (data: any) => {
        this.showLoader = false;
        this.files = [];
        this.dataSelectedToUploadFiles = null;
        this.assignationFileDataList = [ ];
        Swal.fire({
          title: `Los datos se guardaron correctamente`,
          text: ``,
          type: "info",
        });
      },
      (error: any) => {
        this.dataSelectedToUploadFiles = null;
        this.showLoader = false;
        Swal.fire({
          title: `${error.error.message}`,
          text: ``,
          type: "error",
        });
        this.files = [];
        this.assignationFileDataList = [];
      }
    );
  }

  handleCurrentTab(value: string) {
    this.currentTab = value;
  }

  setData() : PaymentProcessBackingRequest {
    const dataSend = new PaymentProcessBackingRequest;
    const {
      affiliateDocumentType,
      affiliateDocument,
    } = this.dataResponseSearchFilter;


    dataSend.affiliateDocumentType = affiliateDocumentType;
    dataSend.affiliateDocument = Number(affiliateDocument);
    dataSend.deductiblePercentage = this.dataSelectedToUploadFiles.deductiblePercentage;
    dataSend.draftNumber = this.dataSelectedToUploadFiles.draftNumber;
    dataSend.filingNumber = this.dataSelectedToUploadFiles.filingNumber;
    dataSend.filingStatus = this.dataSelectedToUploadFiles.filingStatus;
    dataSend.guaranteedValue = this.dataSelectedToUploadFiles.guaranteedValue;
    dataSend.issuerDocumentType = this.dataSelectedToUploadFiles.issuerDocumentType;
    dataSend.issuerDocument = this.dataSelectedToUploadFiles.issuerDocument;
    dataSend.newPayment = this.paymentClaim;
    dataSend.sinisterProduct = this.dataSelectedToUploadFiles.sinisterProduct;
    dataSend.claimedValue = this.dataSelectedToUploadFiles.claimedValue;
    dataSend.recoveryValue = this.dataSelectedToUploadFiles.recoveryValue;
    dataSend.returnCause = this.dataSelectedToUploadFiles.nonRefundCause;
    dataSend.user = this.dataUserLoged.USUARIO;

    return dataSend;
  }

  formatName(name:string) : string {
    const arrayNames = name.split(' ');
    let username:string = '';
    let names: string[] = [];
    arrayNames.forEach((placeName) => { if(placeName.length > 0) return names.push(placeName)});

    username = `${names[0]}.${(names.length > 1)? names[1]: 'covifactura'}`;
    
    return username.toLowerCase();
  }

  validateValueClaims() {
    if(Number(this.paymentClaim) > Number(this.dataSelectedToUploadFiles.claimedValue)) {
      this.toast.warning('El abono no puede ser mayor al valor reclamado.');
    }
  }

  listDocumentsUpload(subProduct: string) {
    const productsType = {
      'FACTURA': [
        new ClaimsUploadFile('Factura','application/pdf','.PDF'),
        new ClaimsUploadFile('XML de la Factura','text/xml','.XML'),
        new ClaimsUploadFile('Notificación al Comprador','application/pdf,image/jpeg,image/jpg','.PDF - .JPG'),
        new ClaimsUploadFile('Trazabilidad Factura','application/pdf,image/jpeg,image/jpg','.PDF - .JPG'),
        new ClaimsUploadFile('Endoso','application/pdf,image/jpeg,image/jpg','.PDF - .JPG'),
        new ClaimsUploadFile('FAU (opcional)','application/pdf,image/jpeg,image/jpg','.PDF - .JPG', false),
        new ClaimsUploadFile('Pagare (opcional)','application/pdf,image/jpeg,image/jpg','.PDF - .JPG', false),
      ],
      'CHQ DIA': [
        new ClaimsUploadFile('Cheque','application/pdf','.PDF'),
        new ClaimsUploadFile('Notificación al Comprador','application/pdf,image/jpeg,image/jpg','.PDF - .JPG'),
        new ClaimsUploadFile('Endoso','application/pdf,image/jpeg,image/jpg','.PDF - .JPG'),
        new ClaimsUploadFile('FAU (opcional)','application/pdf,image/jpeg,image/jpg','.PDF - .JPG', false),
      ],
      'PAGARE': [
        new ClaimsUploadFile('Pagare y Carta de Instruccion','application/pdf,image/jpeg,image/jpg','.PDF - .JPG'),
        new ClaimsUploadFile('Endoso','application/pdf,image/jpeg,image/jpg','.PDF - .JPG'),
      ],
      'POSFECHADO': [
        new ClaimsUploadFile('Cheque - PDF','application/pdf,image/jpeg,image/jpg','.PDF - .JPG'),
        new ClaimsUploadFile('Notificación al Comprador','application/pdf,image/jpeg,image/jpg','.PDF - .JPG'),
        new ClaimsUploadFile('Endoso','application/pdf,image/jpeg,image/jpg','.PDF - .JPG'),
        new ClaimsUploadFile('FAU (opcional)','application/pdf,image/jpeg,image/jpg','.PDF - .JPG', false),
      ],
    }

    if(!productsType.hasOwnProperty(subProduct)) subProduct = 'FACTURA';
    return productsType[subProduct];
  }

  checkFilesRequired() {
    const filesRequired = this.assignationFileDataList
      .filter((element) => element.required == true)
      .map(file => {if(file.uploads.length > 0 && file.uploads[0].image) return true; else return false;});

    return filesRequired.includes(false);
  }
}
